import { gsap, Sine, Power0, Power1, Power2, Power3, Power4 } from "gsap";
// import { ScrollToPlugin } from "gsap/ScrollToPlugin.js";
// import { ScrollTrigger } from "gsap/ScrollTrigger.js";

// CUSTOM PROPERTY
// =======================================================

var lastInnerWidth = window.innerWidth;
let vh = window.innerHeight * 0.01;
document.documentElement.style.setProperty("--vh", vh + "px");

window.addEventListener("resize", function () {
  if (lastInnerWidth != window.innerWidth) {
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vh", vh + "px");
  }
});

// FUNCTION
// =======================================================
function closest(node, selector) {
  // IEや一部ブラウザでは.closet()が実装されていないので自前も用意
  return (
    node.closest ||
    function (_selector) {
      do {
        // nodeとselectorがマッチしたら返す
        if ((node.matches || node.msMatchesSelector).call(node, _selector)) {
          return node;
        }
        // マッチしなかったら親要素を代入
        node = node.parentElement || node.parentNode;
      } while (node !== null && node.nodeType === 1);
      return null;
    }
  ).call(node, selector);
}

// DOM
// =======================================================

const mediaQuery_lg = window.matchMedia("(min-width: 1024px)");
const mediaQuery_md = window.matchMedia("(min-width: 768px)");

// ページが読み込まれた時に実行
window.onload = handle_lg(mediaQuery_lg);
window.onload = handle_md(mediaQuery_md);

function handle_lg(lg) {}

function handle_md(md) {}

// TREEE BUTTONS
// =======================================================
const viewer = document.querySelector(".viewer");
const buttonContainer = document.querySelector("#button-lists");
const buttonPrev = document.querySelector(".btn-prev");
// const buttonReturn = document.querySelectorAll("[data-return]");
const numElem = document.querySelector("[data-num]"); 

let jsonData = null; // JSONデータを格納する変数
const start = 0;


// 外部のJSONファイルを読み込む関数
async function loadJSONFile() {
  try {
    const response = await fetch("/search/assets/js/data.json");
    const jsonData = await response.json();
    return jsonData;
  } catch (error) {
    console.error('Error loading JSON file:', error);
    return null;
  }
}

// 初回のみJSONデータを読み込んで変数に格納
async function loadJSONOnce() {
  if (jsonData === null) {
    const jsonFilePath = 'data.json'; // JSONファイルのパス
    jsonData = await loadJSONFile(jsonFilePath);
  }

}

// JSONデータの読み込みと格納を実行
loadJSONOnce().then(() => {
  if (jsonData) {
    function getRequestObj(id) {
      var obj = jsonData.find(function(value) {
        return value.id == id
      })
      return obj;
    }

    function createButton(id) {
      //次のボタン作成
      var nextBtnsObj = getRequestObj(id);
      // var btnlist = document.createDocumentFragment();
      nextBtnsObj.next.forEach( n => {
        var btnObj = getRequestObj(n);
        var buttonElem = document.createElement('button');
        buttonElem.setAttribute("type", "button");
        buttonElem.setAttribute("data-id", btnObj.id);
        buttonElem.setAttribute("data-anim", "fadeIn");
        buttonElem.classList.add("btn");
        buttonElem.innerHTML = btnObj.text;
        buttonElem.onclick = callBtn;
        buttonContainer.appendChild(buttonElem);
      });
      
      // buttonContainer.appendChild(btnlist);
      var btns = buttonContainer.querySelectorAll("button");
      
      gsap.to("#button-lists", 0.8, {
        opacity: 1,
        onComplete: function(){
        }
      });

    }


    function initButton() {
      createButton(start);
    }

    function callBtn(e){
      // viewer.classList.add('load');
      
      var btnsObj = getRequestObj(e.target.dataset.id);

      if(btnsObj.location) {
        // location.href='../result/'+btnsObj.location;
        window.open('../result/'+btnsObj.location, '_blank')
        return false;
      }

      const buttons = document.querySelectorAll("#button-lists button");
      buttons.forEach((btn) => {
        btn.remove();
      });

      // window.setTimeout(function(){
      //   const buttons = document.querySelectorAll("#button-lists button");
      //   buttons.forEach((btn) => {
      //     btn.remove();
      //   });
      //   createButton(e.target.dataset.id);
      //   viewer.classList.remove('load');
      // }, 500 );

      // カウント
      numElem.dataset.num = btnsObj.hierarchy + 1;

      // ボタン生成
      gsap.to("#button-lists", 0.4, {
        opacity: 0,
        onComplete: function(){
          createButton(e.target.dataset.id);
        }
      });
    

      // 前の質問
      if (buttonPrev){
        buttonPrev.dataset.id = btnsObj.prev;
      }
    }

    //初期化
    initButton();
    
    //クリックイベント
    if (buttonPrev){ 
      buttonPrev.addEventListener("click", function(){
        gsap.to("#button-lists", 0.4, {
          opacity: 0,
          onComplete: function(){
            callBtn();
          }
        });
      });
    }
  }
});


